<template>
	<div class="popupSetting-body">
		<div class="top-header">
			<div class="top-left-box">
				<i class="el-icon-back" @click="goBack"></i><div class="scheme-name">{{editNameText}}</div>
				<el-button type="primary" size="mini" @click='editName' v-if="AuthorityList['16_0002_0002_00']">编辑</el-button>
				<div>
					<div style="display: flex;align-items: center;height: 40px;">
						<div style="width:90px;text-align: right;">
							关联店铺：
						</div>
						<el-radio style="min-height: 40px;;line-height: 40px;" v-model="shopattendway" :label="1">全部门店</el-radio>
						<el-radio style="min-height: 40px;;line-height: 40px;" v-model="shopattendway" :label="0">自定义门店</el-radio>
						<div  v-if="shopattendway === 0" @click="bindShopClick" style="height: 20px;line-height: 20px;margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
							<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
							选择门店
						</div>
						<div v-if="shopattendway === 0" style="display: flex;align-items: center;min-height: 40px;">
							<div style="width:60px;text-align: right;flex-shrink: 0;">
								已选：
							</div>
							<div class="shop-text" :title="shopText">{{shopText}}</div>
						</div>
					</div>
				</div>
			</div>
			<div>
				<el-button type="primary" v-if="AuthorityList['16_0002_0002_00']" size="mini" @click='saveClick'>保存</el-button>
			</div>
		</div>
		<div class="fx-header header-box">
			<p class="header-title">弹窗广告</p>
		</div>
		<div class="container-box">
			<div class="left-box">
				<div class="phone-box">
					<img src="~/images/icon/phone.png" alt="">
					<div class="dialog-box" v-if="!disabledflag">
						<el-carousel height="400px" style="width:250px">
							<el-carousel-item v-for="(item, index) in imgList" :key="index">
								<w-image style="width:100%;height:100%;" v-if="item.imgurl !== ''" :src="item.imgurl"></w-image>
								<img style="width:100%;height:100%;" v-if="item.imgurl === ''" src="~/images/icon/no-img.png"/>
							</el-carousel-item>
						</el-carousel>
						<i class="el-icon-error close-icon"></i>
					</div>
				</div>
			</div>
			<div class="line"></div>
			<div class="right-box">
				<div class="header">弹窗广告</div>
				<div class="row-box">
					<div class="row-box-title">应用/禁用：</div>
					<div>
						<el-radio v-model="disabledflag" :label="false">启用</el-radio>
						<el-radio v-model="disabledflag" :label="true">禁用</el-radio>
					</div>
				</div>
				<div v-show="!disabledflag" style="overflow:auto">
					<div class="row-box">
						<div class="row-box-title" style="width: 130px;">选择弹出广告页面：</div>
						<div>
							<el-radio v-model="showlocation" :label="1">首页</el-radio>
							<el-radio v-model="showlocation" :label="0">采购</el-radio>
						</div>
					</div>
					<div class="row-box">
						<div class="row-box-title">弹出设置：
							<el-tooltip class="item" effect="dark" placement="top">
								<div slot="content">
									*选择'首次进入页面弹出'选项,则第一次打开极速订小程序端显示弹窗广告;<br/>*选择'每次进入页面弹出'选项,则每次关闭极速订小程序再打开小程序时均显示弹窗广告;
								</div>
								<i class="el-icon-info" style="color:var(--fx-primary-color)"></i>
							</el-tooltip>
						</div>
						<div>
							<el-radio v-model="showtime" :label="0">首次进入页面弹出</el-radio>
						</div>
					</div>
					<div class="radio-text">
						<el-radio v-model="showtime" :label="1">每次进入页面弹出</el-radio>
					</div>
					<div class="row-box">
						<div class="row-box-title">图片链接：</div>
					</div>
					<div class="text-box">
						图片建议宽高比3:5，图片大小1MB，图片格式png、jpg、jpeg，所有类别总和最多添加3张
					</div>
					<picLink
						ref="picLink"
						@reloadImg='reloadImg'>
					</picLink>
				</div>
			</div>
		</div>
		<el-dialog
			title="编辑方案名称"
			:visible.sync="editNameShow"
			:close-on-click-modal="false"
			class="img-dialog"
			width="400px"
			append-to-body>
			<div style="text-align: center">
				<el-input
					style="margin-bottom: 10px;width: 300px"
					v-model="tempEditNameText"
					placeholder="请输入方案名称"
					size="mini"
					:maxlength="10"
					>
				</el-input>
				<div style="text-align: center;margin-top: 20px">
					<el-button class="btn" size="small" plain type="primary" @click="close">取消</el-button>
					<el-button class="btn" size="small" plain type="primary" @click="saveName">确认</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			top='100px'
			title="选择适用门店"
			class="dialog-title"
			:visible.sync="shopDialog"
			width="780px"
			append-to-body
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
		<el-dialog
			top='100px'
			title="错误信息提示"
			class="dialog-title"
			:visible.sync="errorDialog"
			width="780px"
			append-to-body
			:close-on-click-modal="false">
			<div class="error-box">
				<div v-for="item in errorList" :key="item">{{item}}</div>
			</div>
			<div style="text-align: center;margin-top: 20px">
				<el-button class="btn" size="small" plain type="primary" @click="errorDialog = false">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import picLink from '@/components/picLink/Index.vue'
import bindShop from '@/components/bindShop/bindShop.vue'
export default {
	name: 'popupSetting',
	components: {
		picLink,
		bindShop
	},
	data () {
		return {
			AuthorityList: {
				'16_0002_0001_00': false,
				'16_0002_0002_00': false
			},
			imgList: [],
			styleAdid: '',
			showSmall: true,
			disabledflag: true,
			showlocation: 0,
			showtime: 0,
			orginData: '',
			editNameText: '自定义弹窗广告方案',
			tempEditNameText: '',
			editNameShow: false,
			shopattendway: 1,
			shopText: '',
			shopDialog: false,
			chooseShop: [],
			shopList: [],
			errorDialog: false,
			errorList: []
		}
	},
	created () {
		if (this.$route.query.id) {
			this.styleAdid = this.$route.query.id
			this.getDetail()
		}
		this.getAuthority('16_0002_0000_00')
	},
	methods: {
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		goBack () {
			this.$router.push('/main/popupList')
		},
		editName () {
			this.tempEditNameText = this.editNameText
			this.editNameShow = true
		},
		saveName () {
			if (!this.tempEditNameText) {
				this.$message.error('方案名称不能为空')
				return false
			}
			this.editNameText = this.tempEditNameText
			this.editNameShow = false
		},
		close () {
			this.editNameShow = false
		},
		bindShopClick () {
			this.shopDialog = true
		},
		reloadShop (data) {
			this.chooseShop = data.chooseData
			this.shopText = data.shopText
			this.shopDialog = false
		},
		reloadImg (data) {
			this.imgList = data.addRotationChartList
		},
		getDetail () {
			let params = {
				styleAdid: this.styleAdid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/style/ad`,
				data: params
			}).then(res => {
				if (res.result) {
					// console.log(res.data)
					this.editNameText = res.data.styleAd.name
					this.shopattendway = res.data.styleAd.relAllShopFlag
					this.chooseShop = res.data.shopIds
					this.shopText = res.data.shopNames
					this.styleAdid = res.data.styleAd.id
					this.disabledflag = res.data.styleAd.disabledflag
					this.showtime = res.data.styleAd.showtime
					this.showlocation = res.data.styleAd.showlocation
					res.data.rotationChartList.forEach(item => {
						item.dateValue = item.datetype === 0 ? [] : [item.begindate, item.enddate]
					})
					this.imgList = res.data.rotationChartList
					let addRotationChartList = []
					this.imgList.forEach(item => {
						let arr = item.imgurl.split('.')
						item.extension = arr[arr.length - 1]
						addRotationChartList.push(item)
					})
					let orginData = {
						styleAdid: this.styleAdid,
						disabledflag: this.disabledflag,
						showtime: this.showtime,
						addRotationChartList: addRotationChartList,
						delRotationChartList: []
					}
					this.orginData = JSON.stringify(orginData)
					this.$refs.picLink.initData(res.data.rotationChartList)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		checkData (data) {
			let flag = false
			data.forEach(item => {
				if (item.imgurl === '') {
					flag = true
				}
			})
			return flag
		},
		saveClick () {
			if (this.shopattendway === 0 && this.chooseShop.length === 0) {
				this.$message.error('请选择关联店铺！')
				return false
			}
			let data = this.$refs.picLink.getAllData()
			let addRotationChartList = data.addRotationChartList
			let delRotationChartList = data.delRotationChartList
			if (addRotationChartList.length === 0 && !this.disabledflag) {
				this.$message.error('保存失败，请添加图片链接！')
				return false
			}
			if (this.checkData(addRotationChartList)) {
				this.$message.error('请上传图片！')
				return false
			}
			addRotationChartList.forEach(item => {
				let arr = item.imgurl.split('.')
				item.extension = arr[arr.length - 1]
			})
			for (let i = 0; i < addRotationChartList.length; i++) {
				const item = addRotationChartList[i]
				if (item.datetype === 1 && item.dateValue.length === 0) {
					this.$message.error('请选择弹窗时间！')
					return false
				}
				let arr = item.imgurl.split('.')
				item.extension = arr[arr.length - 1]
				item.begindate = item.datetype === 0 ? '' : item.dateValue[0]
				item.enddate = item.datetype === 0 ? '' : item.dateValue[1]
			}
			let params = {
				name: this.editNameText,
				styleAdid: this.styleAdid,
				relAllShopFlag: this.shopattendway,
				shopIds: this.chooseShop,
				disabledflag: this.disabledflag,
				showtime: this.showtime,
				addRotationChartList: addRotationChartList,
				delRotationChartList: delRotationChartList,
				showlocation: this.showlocation
			}
			let newData = JSON.stringify(params)
			if (this.orginData === newData) {
				this.$message.warning('页面没有修改内容，无需保存')
				return false
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/style/ad/addOrUpdate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.styleAdid = res.data.styleAdId
					this.$message.success('保存成功')
					this.getDetail()
				} else {
					if (res.msg) {
						this.$message.error(res.msg)
					} else {
						this.errorList = res.data
						this.errorDialog = true
					}
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.popupSetting-body{
	display: flex;
	flex-direction: column;
	flex: 1;
	padding-left: 0 !important;
	background-color: #eceffc !important;
	.top-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #fff;
		padding:0 20px;
		border-bottom: 1px solid #dce2fd;
		line-height: 50px;
		.top-left-box {
			display: flex;
			align-items: center;
			.scheme-name {
				font-size: 14px;
				margin: 0 10px
			}
			.shop-text {
				max-width: 500px;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
		}
		.el-icon-back {
			border-radius 50%
			text-align: center;
			background: #9da6af;
			cursor pointer;
			padding: 3px
		}
		.el-icon-back:before {
			content: "\E6EA";
			color: #fff;
			font-weight: bold;
		}
	}
	.fx-header{
		background-color: #fff;
		padding:0 20px;
		&.header-box {
			height: 50px;
			min-height: 50px;
			line-height: 50px;
			.header-title {
				font-size: 14px;
			}
		}
	}
}
.container-box{
	overflow: hidden
	flex:1;
	display: flex;
	flex-direction: row;
	margin-top:10px;
	background: #fff;
	font-weight: 400;
	.left-box{
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		.close-icon{
			margin-top: 20px;
			font-size: 26px;
			color: #fff
		}
	}
	.phone-box{
		width: 360px;
		height:560px;
		position: relative
		.dialog-box{
			position: absolute;
			width:100%;
			height: 100%
			top:0;
			left:0;
			background-color:rgba(0, 0, 0, 0.3);
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column
		}
		img{
			width: 100%;
			height: 100%
		}
	}
	.right-box{
		flex: 1;
		height:100%;
		overflow: auto
	}
	.line{
		box-sizing: border-box;
		width: 1px;
		height:96%;
		margin: 10px 0;
		background-color: var(--fx-primary-color)
	}
	.row-box{
		margin: 10px 40px;
		display: flex;
		height: 32px;
		line-height: 32px;
		flex-direction: row;
		font-size: 14px;
	}
	.row-box-title{
		width: 100px;
		text-align: left
	}
	.radio-text{
		text-align: left;
		padding-left: 140px
	}
	.text-box{
		text-align: left;
		padding-left: 40px;
		color: #999
	}
}
</style>
<style lang="stylus">
</style>
